import React from 'react';
import { useCart } from '../../utils/contexts/cart-context';
import { IonSpinner } from '@ionic/react';

export default function Adder(props) {
    const { product } = props;

    const [actual, setActual] = React.useState(null);

    const { products, add, addOne, subOne } = useCart();

    const onSubOneHandler = () => subOne(actual.id, actual.note);
    const onAddOneHandler = () => addOne(actual.id, actual.note);

    React.useLayoutEffect(() => {
        let item = products.find(item => item.id === product.id && item.note === product.note);

        if (!item) {
            item = product;
            add(item);
        }
        setActual(item);
    }, [add, product, products]);

    return (
        <div className="adder flex justify-center items-center text-xl font-bold">
            <button type="button" onClick={onSubOneHandler} className="p-4">-</button>
            {actual ?
                <span className="quantity mx-2 py-2 px-4 rounded-full border-2 border-mycia-green">{actual.quantity}</span> :
                <IonSpinner name="bubbles"></IonSpinner>}
            <button type="button" onClick={onAddOneHandler} className="p-4">+</button>
        </div>
    );
}
